import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function PrivacyPolicy() {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = `${t('privacyPolicyTitle')} — KODPİLOT`;
    }, [t]);

    return (
        <div className="legal">
            <div className="legal-inner">
                        <h1 style={{ 
                            color: '#FC0DC3', 
                            fontFamily: 'Chakra Petch', 
                            fontWeight: '700', 
                            fontSize: '36px',
                            marginBottom: '50px', 
                            textAlign: 'left',
                            textTransform: 'uppercase'
                        }}>
                            GİZLİLİK VE KİŞİSEL VERİLERİN KORUNMASI POLİTİKASI
                        </h1>

                        <div className="legal-card">
                            
                            <p style={{ marginBottom: '30px' }}>
                                İşbu Gizlilik ve Kişisel Verilerin Korunması Politikası (“Politika”), Kodpilot Yazılım Teknoloji San. ve Tic. Ltd. Şti. (“Kodpilot” veya “Şirket”) tarafından işletilen www.kodpilot.com internet sitesi üzerinden elde edilen kişisel verilerin işlenmesine ilişkin usul ve esasları açıklamak amacıyla hazırlanmıştır.<br/><br/>
                                Kodpilot, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) ve ilgili mevzuata uygun olarak kişisel verilerin gizliliğini ve güvenliğini sağlamayı taahhüt eder.
                            </p>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>1. Veri Sorumlusu</h2>
                                <p>KVKK uyarınca kişisel verileriniz, veri sorumlusu sıfatıyla:<br/>
                                <strong>Kodpilot Yazılım Teknoloji San. ve Tic. Ltd. Şti.</strong> tarafından işlenmektedir.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>2. İşlenen Kişisel Veriler</h2>
                                <p>Web sitesi ve sunulan hizmetler kapsamında aşağıdaki kişisel veriler işlenebilir:</p>
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                    <li>Kimlik Bilgileri (ad, soyad)</li>
                                    <li>İletişim Bilgileri (e-posta adresi, telefon numarası)</li>
                                    <li>Kullanıcı işlem ve talep bilgileri</li>
                                    <li>IP adresi, cihaz ve tarayıcı bilgileri</li>
                                    <li>Ödeme ve işlem bilgileri</li>
                                    <li>Çerez (cookie) verileri</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>3. Kişisel Verilerin İşlenme Amaçları</h2>
                                <p>Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                    <li>Yazılım ve teknoloji hizmetlerinin sunulması</li>
                                    <li>Satış, ödeme ve faturalama süreçlerinin yürütülmesi</li>
                                    <li>İletişim taleplerinin yanıtlanması</li>
                                    <li>Teknik destek ve müşteri hizmetleri sağlanması</li>
                                    <li>Site güvenliğinin sağlanması</li>
                                    <li>Hukuki yükümlülüklerin yerine getirilmesi</li>
                                    <li>Hizmet kalitesinin ve kullanıcı deneyiminin geliştirilmesi</li>
                                    <li>Yetkili kamu kurum ve kuruluşlarının taleplerinin karşılanması</li>
                                </ul>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>4. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi</h2>
                                <p>Kişisel verileriniz;</p>
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                    <li>Web sitesi üzerindeki formlar,</li>
                                    <li>E-posta, telefon ve dijital iletişim kanalları,</li>
                                    <li>Çerezler ve benzeri teknolojiler,</li>
                                    <li>Ödeme işlemleri sırasında</li>
                                </ul>
                                <p>aracılığıyla otomatik veya kısmen otomatik yollarla toplanmaktadır.</p>
                                <p style={{ marginTop: '15px' }}>Kişisel veriler, KVKK’nın 5. ve 6. maddelerinde belirtilen;</p>
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                    <li>Açık rıza,</li>
                                    <li>Bir sözleşmenin kurulması veya ifası,</li>
                                    <li>Hukuki yükümlülüklerin yerine getirilmesi,</li>
                                    <li>Veri sorumlusunun meşru menfaati</li>
                                </ul>
                                <p>hukuki sebeplerine dayanılarak işlenmektedir.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>5. Kişisel Verilerin Aktarılması</h2>
                                <p>Kişisel verileriniz, KVKK ve ilgili mevzuata uygun olarak;</p>
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                    <li>Yetkili kamu kurum ve kuruluşlarına,</li>
                                    <li>Hukuki ve mali yükümlülüklerin yerine getirilmesi amacıyla yetkili kişi ve kuruluşlara,</li>
                                    <li>Sunucu, barındırma (hosting), e-posta ve teknik altyapı hizmeti sağlayıcılarına</li>
                                </ul>
                                <p>aktarılabilir.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>5.1. Ödeme Hizmetleri Kapsamında Kişisel Verilerin Aktarılması</h2>
                                <p>Web sitemiz üzerinden gerçekleştirilen ödeme işlemleri, Bankacılık Düzenleme ve Denetleme Kurumu (BDDK) tarafından yetkilendirilmiş, PCI-DSS güvenlik standartlarına uygun, harici bir ödeme hizmeti sağlayıcısı altyapısı üzerinden gerçekleştirilmektedir.</p>
                                <p>Bu kapsamda;</p>
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                    <li>Kimlik bilgileri (ad, soyad),</li>
                                    <li>İletişim bilgileri (e-posta adresi),</li>
                                    <li>Ödeme ve işlem bilgileri,</li>
                                    <li>IP ve cihaz bilgileri</li>
                                </ul>
                                <p style={{ marginTop: '10px' }}>yalnızca ödeme işleminin gerçekleştirilebilmesi amacıyla, ilgili ödeme hizmeti sağlayıcısı ile KVKK’ya uygun şekilde paylaşılmaktadır.</p>
                                <p>Kredi kartı ve banka kartı bilgileri Kodpilot Yazılım Teknoloji San. ve Tic. Ltd. Şti. tarafından hiçbir şekilde saklanmamakta, bu bilgiler doğrudan ödeme hizmeti sağlayıcısının güvenli altyapısı üzerinden işlenmektedir.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>6. Kişisel Verilerin Saklanma Süresi</h2>
                                <p>Kişisel verileriniz, işlenme amaçlarının gerektirdiği süre boyunca ve ilgili mevzuatta öngörülen yasal saklama süreleri kadar muhafaza edilir. Sürelerin sona ermesi halinde kişisel veriler silinir, yok edilir veya anonim hale getirilir.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>7. Veri Güvenliği</h2>
                                <p>Kodpilot Yazılım Teknoloji San. ve Tic. Ltd. Şti., kişisel verilerin hukuka aykırı olarak işlenmesini ve yetkisiz erişimini önlemek amacıyla gerekli teknik ve idari güvenlik tedbirlerini almaktadır.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>8. KVKK Kapsamındaki Haklarınız</h2>
                                <p>KVKK’nın 11. maddesi uyarınca veri sahipleri olarak;</p>
                                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                                    <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
                                    <li>İşlenmişse buna ilişkin bilgi talep etme,</li>
                                    <li>Amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
                                    <li>Eksik veya yanlış işlenen verilerin düzeltilmesini isteme,</li>
                                    <li>Kişisel verilerinizin silinmesini veya yok edilmesini talep etme,</li>
                                    <li>İşlemenin hukuka aykırı olması hâlinde zararın giderilmesini talep etme</li>
                                </ul>
                                <p>haklarına sahipsiniz.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>9. Çerezler (Cookies)</h2>
                                <p>Web sitemizde kullanıcı deneyimini geliştirmek ve site performansını analiz etmek amacıyla çerezler kullanılmaktadır. Tarayıcı ayarlarınızdan çerez kullanımını dilediğiniz zaman yönetebilir veya engelleyebilirsiniz.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>10. Politika Güncellemeleri</h2>
                                <p>Kodpilot Yazılım Teknoloji San. ve Tic. Ltd. Şti., işbu Politikayı mevzuat değişiklikleri ve hizmet güncellemelerine bağlı olarak güncelleme hakkını saklı tutar. Güncel politika web sitesinde yayımlandığı tarihten itibaren geçerli olur.</p>
                            </section>

                            <section style={{ marginBottom: '30px' }}>
                                <h2 style={{ color: '#fff', fontSize: '20px', marginBottom: '15px', fontFamily: 'Chakra Petch' }}>11. İletişim</h2>
                                <p>Kişisel verilerinizle ilgili her türlü soru, talep ve başvurularınız için bizimle iletişime geçebilirsiniz:</p>
                                <p><strong>E-posta:</strong> <a href="mailto:info@kodpilot.com" style={{ color: '#FC0DC3', textDecoration: 'none' }}>info@kodpilot.com</a><br/>
                                <strong>Web:</strong> <a href="https://www.kodpilot.com" target="_blank" rel="noreferrer" style={{ color: '#FC0DC3', textDecoration: 'none' }}>www.kodpilot.com</a></p>
                            </section>
                        </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
